import { NEUTRAL_1, NEUTRAL_7 } from '@/colors/colors';
import { css } from '@emotion/css';

export const styTbody = css`
  > tr {
    height: 56px;

    &.row-expand {
      transition: height ease-in-out 0.5s;
    }

    > td {
      padding: 0px 16px;

      text-align: left;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      border-bottom: 1px solid ${NEUTRAL_1};

      &:first-child {
        border-left: 1px solid ${NEUTRAL_1};
      }

      &:last-child {
        border-right: 1px solid ${NEUTRAL_1};
      }
    }
  }
`;

export const styEmptyBody = css`
  text-align: center;
  color: ${NEUTRAL_7};
`;
